export default {
	name: 'CustomSelectDropdown',
	data() {
		return {
			choosenOption: '',
			showDropdown: false,
		};
	},
	props: {
		models: {
			type: Array,
		},
		selectedOption: {
			type: String,
		},
	},
  methods: {
    /**
     * dropdown click event handler
     */
		toggleDropdown() {
			this.showDropdown = !this.showDropdown;
    },
    /**
     * select model event handler
     * @param {String} model 
     */
		selectModel(model) {
			this.choosenOption = model.model_name;
			this.showDropdown = false;
			this.$emit('select-dropdown', this.choosenOption);
    },
    /**
     * Event for clicking outside of dropdown element
     * @param {Object} event 
     */
		handleClickOutside(event) {
			const dropdown = this.$refs.dropdown; 
			if (dropdown && !dropdown.contains(event.target)) {
				this.showDropdown = false;
			}
		},
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
	},
};